import type { CampaignExclusions } from '../types';

const EXCLUSION_LABELS: [keyof CampaignExclusions, string][] = [
  ['expired', 'expired'],
  ['do_not_contact', 'do not contact'],
  ['deleted', 'deleted'],
  ['no_email', 'without an email address'],
  ['duplicate', 'duplicates'],
  ['paused', 'paused'],
  ['in_touch', 'in touch since the last campaign'],
];

/** "3 expired · 1 do not contact" — the members a campaign was not sent to, by reason. */
export function describeExclusions(excluded: CampaignExclusions): string {
  return EXCLUSION_LABELS.filter(([key]) => excluded[key] > 0)
    .map(([key, label]) => `${excluded[key]} ${label}`)
    .join(' · ');
}

export function exclusionTotal(excluded: CampaignExclusions): number {
  return EXCLUSION_LABELS.reduce((sum, [key]) => sum + excluded[key], 0);
}
